// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { USER_MODULE, USER_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { UserApprovedIndex } = lazily(() => import('pages/back-office/user/user-approved'))

const userApprovedRoutes: IRoute[] = [
  {
    path: USER_URL.APPROVED,
    component: UserApprovedIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'user.approved',
        accessCodes: [443],
      },
    },
  },
]

export { userApprovedRoutes }
